import freetext from "../assets/freetext.svg";
import longfreetext from "../assets/longtext.svg";
import multichoice from "../assets/multichoice.svg";
import checkboxes from "../assets/checkboxes.svg";
import ratingscale from "../assets/ratingscale.svg";
export const formEl = [
  {
    label: "Short Free Text",
    value: "text",
    image: freetext,
  },
  {
    label: "Long Free Text",
    value: "textarea",
    image: longfreetext,
  },
  {
    label: "Multiple Choice",
    value: "radio",
    image: multichoice,
  },
  {
    label: "Checkboxes",
    value: "checkbox",
    image: checkboxes,
  },
  {
    label: "Rating Scale",
    value: "rating",
    image: ratingscale,
  }
];